import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { LandingPage } from "./pages/LandingPage";
import { PropertyPage } from "./pages/PropertyPage";
import { SubmissionFormPage } from "./pages/SubmissionFormPage";
import { PreviewPage } from "./pages/PreviewPage";
import { SamplePropertyPage } from "./pages/SamplePropertyPage";
import { ManagePropertyPage } from "./pages/ManagePropertyPage";
import { ModificationPreviewPage } from "./pages/ModificationPreviewPage";
import { AdminLogin } from "./pages/AdminLogin";
import { AdminDashboard } from "./pages/AdminDashboard";
import { DynamicPropertyPage } from "./pages/DynamicPropertyPage";
import { Toaster } from "./components/ui/sonner";
import { isAdminAuthenticated } from "./lib/api";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = isAdminAuthenticated();
  return isAuthenticated ? children : <Navigate to="/admin/login" />;
};

function App() {
  const exportProperty = window.__EXPORT_PROPERTY__;

  if (exportProperty) {
    return (
      <LanguageProvider>
        <BrowserRouter>
          <DynamicPropertyPage sampleProperty={exportProperty} />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </LanguageProvider>
    );
  }

  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/demo" element={<PropertyPage />} />
          <Route path="/submit" element={<SubmissionFormPage />} />
          <Route path="/submit/:license_number/edit" element={<SubmissionFormPage />} />
          <Route path="/manage/:manageToken/edit" element={<SubmissionFormPage />} />
          <Route path="/manage/:manageToken/preview" element={<ModificationPreviewPage />} />
          <Route path="/manage/:token/preview" element={<ManagePropertyPage showPreview />} />
          <Route path="/preview/:license_number" element={<PreviewPage />} />
          <Route path="/manage/:token" element={<ManagePropertyPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/sample-property" element={<SamplePropertyPage />} />
          <Route 
            path="/admin/dashboard" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </LanguageProvider>
  );
}

export default App;
